export const MEDIA_KINDS = {
  image: {
    label: 'Image',
    accept: 'image/jpeg,image/jpg,image/png,.jpg,.jpeg,.png',
    extensions: new Set(['jpg', 'jpeg', 'png']),
    deviceTypes: new Set(['image/jpeg', 'image/jpg', 'image/png']),
    matchesMime: (type = '') => type.startsWith('image/'),
  },
  video: {
    label: 'Video',
    accept: 'video/mp4,video/3gpp,.mp4,.3gp',
    extensions: new Set(['mp4', '3gp']),
    deviceTypes: new Set(['video/mp4', 'video/3gpp']),
    matchesMime: (type = '') => type.startsWith('video/'),
  },
  audio: {
    label: 'Audio',
    accept: 'audio/*,.mp3,.ogg,.aac,.m4a,.opus',
    extensions: new Set(['mp3', 'ogg', 'aac', 'm4a', 'opus', 'wav']),
    deviceTypes: new Set([
      'audio/ogg',
      'audio/mpeg',
      'audio/aac',
      'audio/mp4',
      'audio/x-m4a',
      'audio/wav',
      'audio/x-wav',
      'audio/webm',
    ]),
    matchesMime: (type = '') => type.startsWith('audio/'),
  },
  document: {
    label: 'Document',
    accept: 'application/pdf,.pdf,.xls,.xlsx,.doc,.docx,.csv,.txt',
    extensions: new Set(['pdf', 'xls', 'xlsx', 'doc', 'docx', 'csv', 'txt']),
    deviceTypes: new Set([
      'application/pdf',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'text/csv',
      'text/plain'
    ]),
    matchesMime: (type = '') => {
      const t = type.toLowerCase();
      return t && !t.startsWith('image/') && !t.startsWith('video/') && !t.startsWith('audio/');
    },
  },
};

export const filterMediaByKind = (items = [], kind) => {
  if (!kind || !MEDIA_KINDS[kind]) {
    return items;
  }
  return items.filter((item) => MEDIA_KINDS[kind].matchesMime(item?.type || ''));
};

export const isValidDeviceFileForKind = (file, kind) => {
  const config = MEDIA_KINDS[kind];
  if (!file || !config) {
    return false;
  }

  const mimeType = (file.type || '').toLowerCase();
  const extension = file.name?.split('.').pop()?.toLowerCase()?.split(/[?#]/)[0];

  if (mimeType && config.deviceTypes.has(mimeType)) {
    return true;
  }

  if (mimeType && config.matchesMime(mimeType)) {
    return true;
  }

  // macOS often reports PDFs as application/octet-stream.
  if (
    kind === 'document' &&
    extension === 'pdf' &&
    (!mimeType || mimeType === 'application/octet-stream')
  ) {
    return true;
  }

  return extension ? config.extensions.has(extension) : false;
};
